import { Modal, TemplateCard, TemplateGrid, Divider } from '../../common';
import { ROUTING_TEMPLATES, type TemplateKey } from './schema';

interface TemplatePickerProps {
  isOpen: boolean;
  onClose: () => void;
  /** Called with a template key to seed the editor. */
  onSelect: (templateKey: TemplateKey) => void;
}

/**
 * Create-only template chooser for routing rules. Replaces the old wizard's
 * template step; seeds the editor with defaults for the chosen routing type.
 */
export function TemplatePicker({ isOpen, onClose, onSelect }: TemplatePickerProps) {
  const blankTemplate = ROUTING_TEMPLATES.blank;
  const otherTemplates = (Object.entries(ROUTING_TEMPLATES) as [TemplateKey, (typeof ROUTING_TEMPLATES)[TemplateKey]][])
    .filter(([key]) => key !== 'blank');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create Routing Rule"
      subtitle="Choose a template to pre-configure routing logic, or start from scratch."
      size="lg"
    >
      <div className="space-y-6">
        <TemplateCard
          selected={false}
          onClick={() => onSelect('blank')}
          title={blankTemplate.name}
          description={blankTemplate.description}
          icon={blankTemplate.icon}
          isBlank
        />

        <Divider text="or choose a template" />

        <TemplateGrid columns={3}>
          {otherTemplates.map(([key, template]) => (
            <TemplateCard
              key={key}
              selected={false}
              onClick={() => onSelect(key)}
              title={template.name}
              description={template.description}
              icon={template.icon}
            />
          ))}
        </TemplateGrid>
      </div>
    </Modal>
  );
}
